module.exports = __webpack_public_path__ + "img/mango_tree.4b830a53.png";